import { Upload, Flex } from "antd";
import styles from "./index.module.less";
import { useEffect, useState } from "react";
import message from "@/plugins/message";
import EmailIcon from "../mail.svg?react";
import MobileModal from "@/components/MobileModal";
import SVGIcon from "@/components/SVGIcon";
import ModalCloseIcon from "@/assets/imgs/modal_close.svg?react";
import { copyFormatText } from "@/utils";

const { Dragger } = Upload;
const MobileEmailModal = ({
  visible,
  title,
  onClose,
}: {
  visible: boolean;
  title?: string;
  onClose?: () => void;
}) => {
  if (!visible) {
    return null;
  }
  const handleCopyEmail = () => {
    copyFormatText("jobs@xiaoice.cn");
    message.success("复制成功");
  };
  return (
    <div className={styles.EmailModal}>
      <MobileModal
        open={visible}
        title={title || "投递简历"}
        onClose={() => {
          onClose?.();
        }}
        centered
        header={
          <Flex justify="space-between" align="center" className={styles.header}>
            <div className={styles.title}>{title || "投递简历"}</div>
            <SVGIcon
              className={styles.closeIcon}
              icon={<ModalCloseIcon />}
              onClick={onClose}
              width={20}
            />
          </Flex>
        }
      >
        <Flex align="center" vertical className={styles.content}>
          <SVGIcon width={64} icon={<EmailIcon />} />
          <div>将你的简历邮箱发送到邮箱</div>
          <div>jobs@xiaoice.cn</div>
        </Flex>
        <div className={styles.footer}>
          <div className={styles.submitBtn} onClick={handleCopyEmail}>
            复制邮箱
          </div>
        </div>
      </MobileModal>
    </div>
  );
};

export default MobileEmailModal;
